import { render } from "./SysProcessTemplate.vue?vue&type=template&id=782e58ca&scoped=true"
import script from "./SysProcessTemplate.vue?vue&type=script&lang=js"
export * from "./SysProcessTemplate.vue?vue&type=script&lang=js"

import "./SysProcessTemplate.vue?vue&type=style&index=0&id=782e58ca&lang=less&scoped=true"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-782e58ca"]])

export default __exports__